export default [{"url":"https://golive-0.api.invexerp.io","name":"Branch 1","port":"6534","isStore":true,"isHQ":true}]